import React, { Component } from 'react';
import { Navbar } from 'react-bootstrap';
import NavbarAuthManager from '../containers/authManager';
import NavBarToggler from './navbarToggler';
import cn from 'classnames';
import NavBar from './navBar';

class AppHeader extends Component {
	constructor(props) {
		super(props);
		this.tabs = props.Tabs;
		this.state = {
			menuIsOpen: false,
		};
	}

	setMenuIsOpen = (isOpen) => {
		this.setState({
			menuIsOpen: isOpen,
		});
	};

	render() {
		return (
			<React.Fragment>
				<Navbar inverse fluid>
					<div className='d-flex' style={{ justifyContent: 'space-between' }}>
						<div className='d-flex align-items-center' style={{ overflow: 'hidden' }}>
							<NavBarToggler
								isExtended={this.state.menuIsOpen}
								onClick={() => {
									this.setMenuIsOpen(!this.state.menuIsOpen);
								}}
							/>
							<a href='/' className='ml-1 navbar-brand-text text-overflow-ellipsis'>
								Inobitec DICOM Viewer license server
							</a>
						</div>
						<NavbarAuthManager />
					</div>
				</Navbar>
				<NavBar
					setMenuIsOpen={this.setMenuIsOpen}
					className={cn('show-on-991 ml-4 mr-4', { 'd-none': !this.state.menuIsOpen })}
					tabs={this.tabs}
				/>
			</React.Fragment>
		);
	}
}

export default AppHeader;



// WEBPACK FOOTER //
// ./src/components/appHeader.js